import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import './index.css';

import { Provider, store } from 'lb-store';
import { Events } from './components';
import App from './app/app';
import 'lb-store/src/helpers/i18n';
import 'react-toastify/dist/ReactToastify.min.css';
import { ToastContainer } from 'react-toastify';

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      {/*<LbModal/>*/}
      <BrowserRouter>
        <App />
      </BrowserRouter>
      {/*  <Modal />
        <Guest />
        <User />*/}
      <Events />
      {ReactDOM.createPortal(
        <ToastContainer
          style={{ marginTop: '12.3rem', zIndex: 1000001, width: 'max(var(--toastify-toast-width), fit-content)' }}
          toastClassName={'custom-toast'}
          toastStyle={{
            fontFamily: 'lbet-nus-regular',
            fontSize: '1.35rem',
            backgroundColor: 'var(--bs-dark-blue)',
            color: 'var(--bs-blue-gray)',
          }}
        />,
        document.getElementById('lb-events')
      )}
    </Provider>
  </React.StrictMode>,
  document.getElementById('lb-header')
);
